
import React, { useEffect } from 'react';
import { i18n } from 'core/i18n';
import HireNewPaymentMethod from 'components/hire/hirePaymentMethod/hireNewPaymentMethod';
import {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    CARD_PAYMENT_METHOD_UNIQUE
} from 'constants/index';
import { OKMessage } from 'commonsComponents/OKMessage';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import { recordPage } from 'utilities/tagging';
import { catalogue, analyticsId } from '../../cardChangePaymentMethod/analytics/cardChangeNewPaymentMethodAnalytics';

export const CardChangeNewPaymentMethodStep1 = ({
    immHireCreditLimit,
    immGlobalVariables,
    immHirePaymentMethod,
    setTooltipShown,
    handleTypeChange,
    handleValueChange,
    requestAfiInformation,
    setAFIParams,
    setInneParams,
    newSetHireCreditCardType,
    immFlagBasedFeatures,
    immPdfRevolvingPersistent,
    immCardChangePaymentMethod,
    immCard,
    currentInstallments,
    currentMethod,
    immProfile,
    checkPaymentMehod,
    setCheckPaymentMehod,
    isCheckboxCheckedStep1,
    setIsCheckboxCheckedStep1,
    agreeCheckboxCC,
    setMethod,
    pageName
}) => {
    const { FormattedText } = i18n;
    const method = immCardChangePaymentMethod.getIn(['steps', 0, 'currentPaymentMethod'])
    const paymentMethodType = immHirePaymentMethod.get('type');
    const amount = immCard.getIn(['limit', 'amount'])
    const name = PersonalDataHelper.getFullName(immProfile, false);
    const keyName = `<b>${name}</b>`;
    useEffect(() => {
        handleValueChange(immCardChangePaymentMethod.getIn([__CONTACT_CENTER__ ? 'stepsCC' : 'steps', 0, 'installments']))
    }, [immCardChangePaymentMethod])

    useEffect(() => {
        const taggingData = catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_1_VIEW]({})
        if (taggingData) {
            recordPage(taggingData)
        }
    }, []);

    const getTinValue = (creditType = 'open-credit') => {
        const tinValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tin']),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tin']),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_tin']),
        };
        return tinValues[creditType];
    };
    const getTaeValue = (creditType, tae) => {
        const taeValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', tae]),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', tae]),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', tae]),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', tae]),
        };

        return taeValues[creditType];
    };
    const getInstallmentsOptions = () => {
        const method = immHirePaymentMethod.get('type');

        switch (method) {
            case CARD_PAYMENT_METHOD_FIXED:
                return immCardChangePaymentMethod.getIn(['steps', 0, 'fixedInstallments', 'options']);
            case CARD_PAYMENT_METHOD_VARIABLE:
                return immCardChangePaymentMethod.getIn(['steps', 0, 'variableInstallments', 'options']);
            default:
                return false;
        }
    }
    const getCardTypeName = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');

        switch (true) {
            case isDiamond:
                return 'diamond';
            case isOpenCredit:
                return 'open-credit';
            case isPremium:
                return 'premium';
            case isViaT:
                return 'viat';
            default:
                return 'open-credit';
        }
    };
    const installmentsOptions = getInstallmentsOptions();
    return (
        <section className="card-change-payment-method-step-one">
            <article className="card-change-payment-method-step-one__section">
                <header className="card-change-payment-method-step-one__header">
                    <FormattedText
                        value="cardChangePaymentMethod-paymentMethod"
                        className="card-change-payment-method-step-one__title"
                    />
                </header>
                <FormattedText
                    value="cardChangePaymentMethod-warningMessage"
                    className="card-change-payment-method-step-one__warning-message"
                />
                {__CONTACT_CENTER__ &&
                    <BlockInfo>
                        <p className="requiredReadingStrong">
                            <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                        </p>
                        <FormattedText value="cardChangePaymentMethod-infoBodyOffice" />
                    </BlockInfo>
                }
                <HireNewPaymentMethod
                    immHireCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isNerudaCard={true}
                    newSetCardLimit={true}
                    setTooltipShown={setTooltipShown}
                    handleTypeChange={handleTypeChange}
                    handleValueChange={handleValueChange}
                    requestAfiInformation={requestAfiInformation}
                    setAFIParams={setAFIParams}
                    setInneParams={setInneParams}
                    newSetHireCreditCardType={newSetHireCreditCardType}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                    getTinValue={getTinValue}
                    getTaeValue={getTaeValue}
                    newOptions={installmentsOptions}
                    paymentAmount={amount}
                    creditType={getCardTypeName()}
                    method={method}
                    currentInstallments={currentInstallments}
                    isCheckboxChecked={true}
                    isCheckboxCheckedStep1={isCheckboxCheckedStep1}
                    agreeCheckboxCC={agreeCheckboxCC}
                    setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
                    checkPaymentMehod={checkPaymentMehod}
                    setCheckPaymentMehod={setCheckPaymentMehod}
                    checkoOperationPaymentMethod={true}
                    setMethod={setMethod}
                    pageName={pageName}
                />
                {__CONTACT_CENTER__ && !isPrintOfficeMode() ?
                    <>
                        {paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE ? (
                            <BlockInfo>
                                <p className="requiredReadingStrong">
                                    <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                                </p>
                                <FormattedText value="cc_hireNewCreditCard-step1InfoMonthlyPayment" />
                            </BlockInfo>)
                            : null}
                        <BlockInfo>
                            <FormattedText value={'cardChangePaymentMethod-blockFinalInfo'} injectedStrings={[keyName]} />
                        </BlockInfo>
                    </>
                    :
                    <OKMessage type="informative">
                        <FormattedText value={currentMethod === CARD_PAYMENT_METHOD_UNIQUE ? 'hireNewCreditCard-step1Info' : 'hireNewCreditCard-step1InfoPA'} />
                    </OKMessage >
                }
            </article>
        </section>
    );
};

